/**
 * @deprecated
 * Please refer to {@link UrqlClientError} in @/src/integrations/urql/errors instead.
 */
export class GraphQLResponseError extends Error {
  constructor(msg?: string, originalError?: Error) {
    super(msg);
    this.name = 'GraphQLResponseError';
    this.cause = originalError;
  }
}

/**
 * @deprecated
 * Please refer to {@link UrqlClientError} in @/src/integrations/urql/errors instead.
 */
export class GraphqlNetworkError extends Error {
  constructor(msg?: string, originalError?: Error) {
    super(msg);
    this.name = 'GraphqlNetworkError';
    this.cause = originalError;
  }
}
